import React from 'react';

export const Footer = () => (
  <p className='footer'>2021 © All rights reserved</p>
);
